import styled from '@emotion/styled';
import { Text, Button } from '@blueprint/ui';
import { css } from '@emotion/react';

const headerHeight = '3.5rem';
const updateButtonMargin = '-1rem';

export const HeaderWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        width: 100%;
        height: ${headerHeight};
        align-items: center;
        justify-content: center;
        display: flex;
        position: relative;
        margin-bottom: ${spacing['16px']};
    `
);

export const ModalCloseIconWrapper = styled.div(
    () => css`
        position: absolute;
        right: 0;
    `
);

export const StyledDropdown = styled.select(
    ({ theme: { colors, type } }) => css`
        border: 0;
        color: ${colors['primary-brand']};
        font-weight: ${type.semiBold};
        font-size: 1rem;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        text-overflow: '';
        font-family: inherit;
        text-align-last: right;
        background-color: ${colors.white};
    `
);

// TODO: alias box-shadow with fixed background
export const StickyWrapperUpdateButton = styled.div(
    ({ theme: { boxShadow, spacing, buttons, mediaQueries } }) => css`
        position: fixed;
        bottom: 0;
        min-width: 100%;
        background: ${buttons.primaryInverted.backgroundColor};
        display: block;
        z-index: 4;
        box-shadow: ${boxShadow['200']};
        margin: 0 ${updateButtonMargin};
        padding: ${spacing['16px']} ${spacing['8px']};

        ${mediaQueries.medium} {
            position: initial;
            box-shadow: none;
        }
    `
);

type StyledButtonProps = {
    isDisabled?: boolean;
};

export const UpdateButton = styled(Button)<StyledButtonProps>((props) => {
    const { isDisabled = false } = props;
    return css`
        opacity: ${isDisabled ? 0.4 : 1};
        cursor: ${isDisabled ? 'default' : 'pointer'};
    `;
});

export const ModalContentWrapper = styled.div(
    ({ theme: { mq } }) => css`
        margin-bottom: 60px;

        ${mq.small} {
            margin-bottom: 60px;
        }
    `
);

export const StyledLabel = styled(Text)(css``);

export const Wrapper = styled.div(
    ({ theme: { spacing } }) => css`
        display: flex;
        justify-content: space-between;
        padding: ${spacing['16px']} 0;
    `
);

export const FilterWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin: 0;
        width: 100%;
        padding-bottom: ${spacing['24px']};
    `
);

export const LocationFilterWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin: 0;
        width: 100%;
        padding-bottom: ${spacing['24px']};
        padding-top: ${spacing['24px']};
        position: relative;
        z-index: 4;
    `
);

export const PropertyTypeRadio = styled.div(
    () => css`
        width: 50%;
        z-index: 0;
    `
);

export const StyledFiltersModal = styled.div(
    ({ theme: { spacing } }) => css`
        padding: ${spacing['16px']};
    `
);

export const RadiusDropdownWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin-top: ${spacing['24px']};
    `
);

export const SelectedPropertyTypeWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['24px']};
    `
);

export const FilterDivider = styled.div(
    ({ theme: { colors } }) => css`
        width: 100%;
        position: absolute;
        right: 0px;
        border-top: solid 1px ${colors['grey-aluminium']};
    `
);

export const FindHomeTextWrapper = styled.div(({ theme: { spacing } }) => {
    return css`
        margin-bottom: ${spacing['24px']};
        margin-top: ${spacing['16px']};
    `;
});

export const PriceFrequencyWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        width: 100%;
        margin-bottom: ${spacing['16px']};
    `
);
